import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductLogisticGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-logistic-group';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'product-logistic-group-lov',
  templateUrl: './product-logistic-group-lov.component.html',
  styleUrls: ['./product-logistic-group-lov.component.scss']
})


export class ProductLogisticGroupLovComponent extends GenericLovComponent {

    @Input() code         : string; 
    @Input() name         : string; 

    productLogisticGroups: ProductLogisticGroup[] = [];

    columns = [
        {  prop: 'productLogisticGroupCode', name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]
    

//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<ProductLogisticGroupLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "productLogisticGroup";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.productLogisticGroups = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : ProductLogisticGroup){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
